import WebsiteEntertainmentModel from '@/models/services/website/WebsiteEntertainmentModel';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import doc                       from '@widesk-core/decorators/doc';

export default class StandMeModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'id': id;
		'partial': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'standStatusHistories.createdAt[before]': string | Date;
		'standStatusHistories.createdAt[strictly_before]': string | Date;
		'standStatusHistories.createdAt[after]': string | Date;
		'standStatusHistories.createdAt[strictly_after]': string | Date;
		'standStatus': string;
		'standTypology': id;
		'standTaxonomies.taxonomy': id;
		'exhibitor': id;
		'websiteEntertainment': id;
		'hall': id;
		'slot': id;
		'slug': id;
		'standStatusHistories.standStatus': string;
		'standPages.standPageValidationStatus': string;
		'search': string;
	};

	private declare _tsSorts: {
		daisukiCount: string;
		id: string;
		hall: string;
		slot: string;
		title: string;
		createdAt: string;
		updatedAt: string;
	};

	static get path(): string {
		return 'stands/me';
	}

	@doc.string declare title: string;
	@doc.string declare slug: string;
	@doc.string declare hall: string;
	@doc.string declare slot: string;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;

	@doc.model(WebsiteEntertainmentModel) declare websiteEntertainment: WebsiteEntertainmentModel;
}
